var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "class-scene_svgrepo.com",
    clipPath: "url(#clip0_2495_53634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.85994 4.11217C3.67577 4.11217 4.33675 3.45064 4.33675 2.63533C4.33675 1.81918 3.67577 1.1582 2.85994 1.1582C2.04375 1.1582 1.38281 1.81918 1.38281 2.63533C1.38281 3.45064 2.04375 4.11217 2.85994 4.11217Z",
    fill: "#394141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.88084 8.61416C7.88084 8.58407 7.87584 8.55535 7.87201 8.52634L10.078 6.92529C10.2166 6.8245 10.2478 6.62959 10.147 6.49069C10.0885 6.41036 9.99436 6.3623 9.89494 6.3623C9.82895 6.3623 9.76602 6.38301 9.71244 6.42168L7.50203 8.02607C7.41973 7.98852 7.32944 7.96616 7.23308 7.96616H6.03151L5.73992 6.30602C5.57979 5.46891 5.2438 4.81152 4.52816 4.81152H1.49418C0.77857 4.81152 0 5.59009 0 6.30602V11.2702C0 11.628 0.289898 11.9182 0.647719 11.9182C0.823887 11.9182 0.647719 11.9182 1.09997 11.9182L1.34624 16.1518C1.34624 16.5326 1.65519 16.8413 2.03593 16.8413C2.3214 16.8413 3.0343 16.8413 3.41504 16.8413C3.79578 16.8413 4.10446 16.5326 4.10446 16.1518L4.42803 7.76602H4.44431L4.62959 8.58407C4.6909 8.9742 5.02661 9.26188 5.42144 9.26188H7.23319C7.59094 9.26188 7.88084 8.97198 7.88084 8.61416ZM2.39154 7.69391V5.33412H3.23972V7.69391L2.78912 8.22541L2.39154 7.69391Z",
    fill: "#394141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.6875 1.66895V7.06188H7.53568V2.51709H17.1482V10.6219H7.53568V9.60171H6.6875V11.47H17.9964V1.66895H6.6875Z",
    fill: "#394141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9632 13.6612C10.9632 13.0002 10.4276 12.4648 9.76689 12.4648C9.10592 12.4648 8.57031 13.0002 8.57031 13.6612C8.57031 14.3216 9.10592 14.8575 9.76689 14.8575C10.4275 14.8575 10.9632 14.3216 10.9632 13.6612Z",
    fill: "#394141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.76187 15.499C8.90901 15.499 8.18455 16.0587 7.90625 16.842H11.6175C11.3392 16.0586 10.6147 15.499 9.76187 15.499Z",
    fill: "#394141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.1194 13.6612C16.1194 13.0002 15.5838 12.4648 14.9231 12.4648C14.2622 12.4648 13.7266 13.0002 13.7266 13.6612C13.7266 14.3216 14.2622 14.8575 14.9231 14.8575C15.5838 14.8575 16.1194 14.3216 16.1194 13.6612Z",
    fill: "#394141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.926 15.499C14.0731 15.499 13.3486 16.0587 13.0703 16.842H16.7816C16.5033 16.0586 15.7788 15.499 14.926 15.499Z",
    fill: "#394141"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2495_53634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/created.1cfd4aed07e222e42b8ae81145815678.svg";
export { ForwardRef as ReactComponent };